import { ifAuthenticated } from '@/router/before'

export const dictsPages = [
  {
    path: '/dicts/universities',
    name: 'UniversitiesDictRoute',
    meta: {
      icon: ['fas', 'university'],
      isDisplayInSidebar: true,
      group: 'Справочники',
      displayName: 'Университеты',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "UniversitiesDictRoute" */ '@/views/dicts/UniversitiesDictRoute.vue'
      ),
  },
  {
    path: '/dicts/program-types',
    name: 'ProgramTypesDictRoute',
    meta: {
      icon: ['fas', 'book'],
      isDisplayInSidebar: true,
      group: 'Справочники',
      displayName: 'Типы программ',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ProgramTypesDictRoute" */ '@/views/dicts/ProgramTypesDictRoute.vue'
      ),
  },
]
